import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdateMatchProfileModel } from "~pages/MatchProfiles/types/updateMatchProfileModel.ts";
import type { FixtureProfileResponse } from "~types/fixtureProfile.ts";

export const useUpdateMatchProfile = () => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<FixtureProfileResponse, Error, UpdateMatchProfileModel>({
    mutationFn: async ({ profileId, ...updateData }) =>
      await request<FixtureProfileResponse>(`${sport}/o/${organizationId}/fixtureProfiles/${profileId}`, {
        method: "PUT",
        body: updateData,
      }),
    onSuccess: async (_response, { profileId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["matchProfiles", sport, organizationId] }),
        queryClient.invalidateQueries({ queryKey: ["matchProfiles", sport, organizationId, profileId] }),
      ]);
    },
  });
};
